module.exports = __webpack_public_path__ + "fonts/TTNormsPro-ExtraBold.a18f5f7d.woff2";